<template lang="pug">
    gmh-registration(
        :settings="settings"
        :translations="translations"
    )
</template>

<script>
export default {
    name: 'registration-page',

    data() { return {
        settings: {
            showNotice: false,
            login: {
                route: 'login-page',
            },
            form: {
                fields: {
                    username: {
                        attr: {
                            lazy: true,
                        },
                    },
                    password: {
                        show: true,
                        attr: {
                            lazy: true,
                        },
                    },
                    first_name: {
                        show: false,
                        validations: false,
                    },
                    last_name: {
                        show: false,
                        validations: false,
                    },
                    terms: {
                        show: true,
                        urls: {
                            terms: {
                                url: '/terms-of-use',
                            },
                            privacy: {
                                url: '/privacy-policy',
                            },
                        },
                    },
                    subscribe: {
                        show: true,
                    },
                },
            },
            submitButtonTitle: 'Register',
            noSuccessScreen: false,
        },
        translations: {
            title: 'Let’s get started',
            login: {
                label: 'Already have an account?',
                link: 'Log In',
            },
            form: {
                fields: {
                    password: {
                        label: 'Password',
                    },
                    terms: {
                        urls: {
                            general: 'I agree to Platform\'s ',
                            terms: 'Terms of Service',
                            and: ' and ',
                            privacy: 'Privacy Policy',
                        },
                    }
                },
            },
        },
    }},
}
</script>
